import React from "react";
import {
    ChunkLoadErrorBoundary,
    clearChunkReloadMark,
} from "./ChunkLoadErrorBoundary";
import { AppBackdropProgress } from "./Progress/AppBackdropProgress";
import { messaging } from "JS/Helpers/UserMessaging";

interface LazyRouteProps {
    children?: React.ReactNode;
}

const ChunkResolved = () => {
    React.useEffect(() => {
        clearChunkReloadMark();
    }, []);

    return null;
};

export const LazyRoute = (props: LazyRouteProps) => (
    <ChunkLoadErrorBoundary>
        <React.Suspense
            fallback={
                <AppBackdropProgress
                    open
                    backdropText={messaging?.loader?.loadingSession}
                />
            }
        >
            {props.children}
            <ChunkResolved />
        </React.Suspense>
    </ChunkLoadErrorBoundary>
);
